Game.Utils.Signposts = {

	/**
	 * Is the message signpost currently being read or not.
	 *
	 * @type {Boolean}
	 */
	active: false,

	/**
	 * The modal overlay background.
	 *
	 * @type {Object}
	 */
	overlay: null,

	/**
	 * The text object that sets the message string.
	 *
	 * @type {Object}
	 */
	overlay_text: null,

	/**
	 * The image that displays the overlay text.
	 *
	 * @type {Object}
	 */
	overlay_text_image: null,

	/**
	 * Info about the zone being used.
	 * @type {Object}
	 */
	zone: {},

	/**
	 * Time it takes to fade in the message and overlay.
	 * @type {Number}
	 */
	fade_duration: 120,

	/**
	 * Wait timer.
	 *
	 * @type {Number}
	 */
	wait_timer: 0,


	wait_timer_limit: 250,

	tween_text: null,

	tween_overlay: null,

	/**
	 * Initialize the signpost displays. Only needs to be called once.
	 *
	 * @param  {[type]} layers [description]
	 * @return {[type]}        [description]
	 */
	init: function( layers ) {

		this.overlay = new Phaser.Graphics( game );
		this.overlay.beginFill( Game.background_color, 0.8 );
		this.overlay.drawRect( 0, 0, game.width, game.height );
		this.overlay.endFill();

		layers.groupModal.add( this.overlay );

		this.overlay.alpha = 0;

		this.overlay_text = game.add.retroFont( 'font', 4, 6, Game.font_set, 8, 3, 1, 2, 1 );
		this.overlay_text.multiLine = true;
		this.overlay_text.autoUpperCase = false;

		this.overlay_text_image = game.add.image( game.width / 2, game.height / 2, this.overlay_text );
		this.overlay_text_image.anchor.setTo( 0.5, 0.5 );
		this.overlay_text_image.alpha = 0;

		layers.groupModal.add( this.overlay_text_image );

	},


	/**
	 * Display a signpost and it's message.
	 *
	 * @param  {[type]} message [description]
	 * @param  {[type]} zone    [description]
	 * @return {[type]}         [description]
	 */
	display: function( message, zone ) {

		// Already active so lets leave early.
		if ( this.active ) {
			return;
		}

		if ( undefined === message ) {
			return;
		}

		// Use a timer to reduce the liklihood of the player going through a
		// square and seeing the sign when they are not interested.
		this.wait_timer += game.time.elapsed;

		// Check the waited time against the limit. If it's greater then lets
		// see the signpost.
		if ( this.wait_timer > this.wait_timer_limit ) {
			this.show( message, zone );
		}

	},


	/**
	 * Show a sign.
	 *
	 * @param  {[type]} message [description]
	 * @param  {[type]} zone    [description]
	 */
	show: function( message, zone ) {

		// Save the current zone so that we can check when we leave it.
		this.zone = zone;

		message = this.process_message( message );

		// set overlay message
		this.overlay_text.text = Game.Utils.Text.wrap( message );

		this.stopTween();

		// add tweens
		this.tween_overlay = game.add.tween( this.overlay ).to( { alpha: 1 }, this.fade_duration ).start();
		this.tween_text = game.add.tween( this.overlay_text_image ).to( { alpha: 1 }, this.fade_duration ).start();

		// Set the signpost as active.
		this.active = true;

	},


	/**
	 * Hide a signpost and reset values so that it can be reused.
	 */
	hide: function() {

		this.active = false;
		this.zone = {};
		this.wait_timer = 0;

		var fade_duration = Math.ceil( this.fade_duration / 2 );

		this.stopTween();

		this.tween_overlay = game.add.tween( this.overlay ).to( { alpha: 0 }, fade_duration ).start();
		this.tween_text = game.add.tween( this.overlay_text_image ).to( { alpha: 0 }, fade_duration ).start();

	},


	stopTween: function() {

		if ( this.tween_overlay ) {
			this.tween_overlay.stop();
		}

		if ( this.tween_text ) {
			this.tween_text.stop();
		}

	},


	process_message: function( message ) {

		console.log( message );

		message = message.replace( '[PHILOSOPHY]', Game.Utils.Philosophy.getRandom() );
		message = message.replace( '[COINS-FOUND]', Game.Utils.Hud.coins.getValue() );
		message = message.replace( '[COINS-TOTAL]', Game.Utils.ManageCoins.getTotal() );

		return message;

	},


	/**
	 * Update the signposts.
	 *
	 * This turns off signpost display once you leave the signpost zone.
	 *
	 * @param  {[type]} player [description]
	 * @return {[type]}       [description]
	 */
	update: function( player ) {

		if ( this.active && this.zone && ! Game.Utils.MapZones.in_zone( player, this.zone ) ) {

			this.hide();

		}

	},

};
